import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ReportService } from '../report.service';
import { UtilService } from '../../../service/util.service';
import { AlertController, ModalController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { UserProfile } from '../../../models/user-profile.model';
import { IonicSelectableComponent } from 'ionic-selectable';
import * as XLSX from 'xlsx';
import { ReportCashierCounterListComponent } from '../../../component/report-cashier-counter-list/report-cashier-counter-list.component';

@Component({
  selector: 'app-report-member-voucher',
  templateUrl: './report-member-voucher.page.html',
  styleUrls: ['./report-member-voucher.page.scss'],
})
export class ReportMemberVoucherPage implements OnInit {

  @Input() counterList: any[];
  @ViewChild('counterComponent', { static: false }) counterComponent: IonicSelectableComponent
  
  dataReport:any[]=[];
  maxDate: string;
  token: any;
  userProfile: UserProfile = new UserProfile();
  counterData:any=[];
  counterByLogin : any;
  counterId:any ='';
  selectedCounters: any[]=[];
  selectedRange = 'today';
  startDate: string;
  endDate: string;
  formattedRange = '';
  showBtnCounterList:boolean=false;
  voucherStatus:any='0';
  constructor(
    private storage: Storage,
    private reportService: ReportService,
    private utilService:UtilService,
    private alertController:AlertController,
    private modalController:ModalController,
    private toastCtrl:ToastController
  ) { }

  ngOnInit() {
      const year = new Date().getFullYear() + 3;
      this.maxDate = `${year}-12-31`;
      Promise.all([
          this.storage.get('user_token'),
          this.storage.get('user_profile')
      ])
      .then(([token, profile]) => {
        if(token) {
          this.setDefaultToday();
          this.token = token;
          this.utilService.loadingPresent('Harap tunggu...')
          .then(() => {
            this.userProfile = new UserProfile(profile);
            this.counterByLogin = this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list;
            this.utilService.loadingDismiss();
            let options = { 
              "token": this.token,
              "branch_id": '',
              "counter_id": this.counterByLogin 
            };
            this.reportService.getCounterByBranchId(options).subscribe((response) => {
              this.utilService.loadingDismiss();
              this.counterData = response.results;
              let checkedCounter =this.counterId !=='' ? this.counterId :this.counterByLogin ;
              let counterIdSplit = checkedCounter !== '' ? String(checkedCounter).split(',') : [];
              let idCounter='';
              for(let i= 0; i < checkedCounter.length; i++) {
                let selectedCounter: any = this.counterData.find(x => x.id ==  counterIdSplit[i]);
                if(selectedCounter){
                  let idx =this.counterData.indexOf(selectedCounter);
                  this.selectedCounters.push(this.counterData[idx]);          
                  idCounter += this.counterData[idx]['id']+',';
                }
              }
              idCounter = idCounter.replace(/(^,)|(,$)/g, "");
              this.counterId = idCounter; let loopCounter = 0;
              if(this.selectedCounters.length >5) {
                loopCounter = 5;
                this.showBtnCounterList = true;
              } else {
                loopCounter = this.selectedCounters.length;
                this.showBtnCounterList = false;
              }
              this.getData();
            }, () => {});
          })
        }    
      })
    }
    ionViewDidEnter(){}
    setDefaultToday() {
      const today = new Date();
      const dateStr = today.toISOString().split('T')[0];
      this.startDate = dateStr;
      this.endDate = dateStr;
      this.formattedRange = this.formatDateRange(today, today);
    }
  
    async getData(){
      if (!this.startDate || !this.endDate) {
        const alert = await this.alertController.create({
          header: 'Peringatan',
          message: 'Periode tanggal belum lengkap.',
          buttons: ['OK'],
        });
        await alert.present();
        return;
      }
      if ( !this.counterId) {
        this.presentAlert('Mohon Pilih Counter  terlebih dahulu!');
        return;
      }
      this.utilService.loadingPresent('Harap tunggu...')
      .then(() => {
        this.dataReport = [];
        let options={
          "start_date":this.startDate,
          "end_date":this.endDate
        }
      this.reportService.reportMemberVoucher(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        if (response.status.code == 200) {
          this.dataReport = response.results;
          
          if(this.voucherStatus=='a'){
            this.dataReport = this.dataReport.filter(x=>x.voucher_status=='active');
          }
          else if(this.voucherStatus=='u'){
            this.dataReport = this.dataReport.filter(x=>x.voucher_status=='used');
          }
          else if(this.voucherStatus=='e'){
            this.dataReport = this.dataReport.filter(x=>x.voucher_status=='expired');
          }
        }
      }, () => {
          this.utilService.loadingDismiss();
          this.toastCtrl.create({ duration: 2000, message: 'Gagal mendapatkan data Report!' }).then(t => t.present());
        });
      })
    }
    async presentAlert(message: string) {
      const alert = await this.alertController.create({
        message: message,
        buttons: ['OK'],
      });
      await alert.present();
    }
  
    applyFilter() {
      if(this.selectedRange === 'custom'){
        this.applyCustom();
      }
      else{
        this.getData();
      }
    }
  
    toggleCounterItems() {
      this.counterComponent.toggleItems(
        this.counterComponent.itemsToConfirm.length ? false : true
      );
    }
  
    confirmCounter() {
      this.counterComponent.confirm();
      this.counterComponent.close();  
      this.counterList = [];
      this.counterList = this.counterComponent.value;
      let idCounter ='';
      for(let i=0;i<this.counterList.length;i++){
        idCounter += this.counterList[i].id+',';
      }
      idCounter = idCounter.replace(/(^,)|(,$)/g, "");
      this.counterId = idCounter;
    }
    cleanValue(val: any): number | string {
      const num = Number(val);
      if (isNaN(num)) return val;
      return num === 0 ? 0 : num;
    }
  
    exportToExcel() {
      let dataForExport = [];
      if(this.dataReport.length>0){
        for (let i = 0; i < this.dataReport.length; i++) {
          const item = this.dataReport[i];
         let row: any = {
            "No": i + 1,
            "Customer ID": item.customer_id,
            "Customer Name": item.customer_name,
            "No HP": item.phone,
            "Gender": item.gender,
            "Tanggal Lahir": item.birth_date,
            "Provinsi": item.province_name,
            "Tier": item.tier_name,
            "Voucher Code": item.voucher_code,
            "Exp Date Voucher": item.end_date,
            "Type Voucher": item.voucher_type,
            "Used Date": item.used_date,
            "Nomor Struk": item.receipt_no,
            "Status": item.voucher_status
          };
          dataForExport.push(row);
        }
      }
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataForExport);
      
      const objectMaxLength: number[] = [];
      dataForExport.forEach(row => {
        Object.values(row).forEach((value, colIndex) => {
          const length = String(value).length;
          objectMaxLength[colIndex] = Math.max(objectMaxLength[colIndex] || 0, length);
        });
      });
      Object.keys(dataForExport[0]).forEach((header, colIndex) => {
        objectMaxLength[colIndex] = Math.max(objectMaxLength[colIndex] || 0, header.length);
      });
      ws['!cols'] = objectMaxLength.map(width => ({ wch: width + 2 }));
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, 'Laporan Member Voucher.xlsx');
    }
  
    async showCounterList() {
      const modal = await this.modalController.create({
        component: ReportCashierCounterListComponent,
        componentProps: {
          counterList: this.selectedCounters
        },
        backdropDismiss: false
      });
      return await modal.present();
    }
    applyPreset() {
      const today = new Date();
      let start: Date, end: Date;
      switch (this.selectedRange) {
        case 'today':
          start = end = today;
          break;
        case '7days':
          start = new Date(today);
          start.setDate(today.getDate() - 6);
          end = today;
          break;
        case '30days':
          start = new Date(today);
          start.setDate(today.getDate() - 29);
          end = today;
          break;
        case 'month':
          start = new Date(today.getFullYear(), today.getMonth(), 1);
          end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          break;
        case 'custom':
          // tunggu user pilih manual
          return;
      }
      this.startDate = start.toISOString().split('T')[0];
      this.endDate = end.toISOString().split('T')[0];
      this.formattedRange = this.formatDateRange(start, end);
    }
  
    async applyCustom() {
      const start = new Date(this.startDate);
      const end = new Date(this.endDate);
      this.formattedRange = this.formatDateRange(start, end);
      // 🧩 VALIDASI: pastikan tanggal akhir tidak kurang dari tanggal awal
      if (end < start) {
        const toast = await this.toastCtrl.create({
          message: 'Tanggal "Sampai" tidak boleh lebih awal dari "Dari".',
          duration: 2500,
          color: 'danger',
          position: 'top'
        });
        toast.present();
        return;
      }
      this.getData();
    }
  
    formatDateRange(start: Date, end: Date) {
      const opt: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' };
      return `${start.toLocaleDateString('id-ID', opt)} - ${end.toLocaleDateString('id-ID', opt)}`;
    }

}
